module.exports = __webpack_public_path__ + "img/1F1F2-1F1F0.6b1a630f.svg";